import { Button, EmptyState, Page, PageHeader } from '@platform/design-system';
import { RouterLink } from '@platform/app-kit';
import { useDocumentTitle } from '../shell/document-title.ts';

export function NotFoundPage() {
  useDocumentTitle('Page not found');
  return (
    <Page>
      <PageHeader title="Page not found" />
      <EmptyState
        title="There's nothing at this address"
        description="The link may be old, or the page may have moved."
        action={
          <Button component={RouterLink} href="/" variant="contained">
            Back to home
          </Button>
        }
      />
    </Page>
  );
}
